import { sortBy } from 'lodash';

import { EstimatePart } from '../../../../generated/graphql';

export function orderParts(parts: EstimatePart[]): EstimatePart[] {
	// TODO: reorder and group in the right way
	return sortBy(parts, ['belongsTo', 'name']);
}
